import React, { useState } from "react";
import { Box, Grid, useMediaQuery } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";

import Heading from "./Heading";
import Pool1 from "./pool1";
import { Record } from ".";
import Loader from "./loader";

import donuts from "../assets/cal-donuts.png";

function ValueLabelComponent(props) {
  const { children, value } = props;

  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  value: PropTypes.number.isRequired,
};

function Calculator({ apr, init, stakeDetails }) {
  const matches = useMediaQuery("(max-width:750px)");

  const [loading, setloading] = useState(false);

  return (
    <Box mt={8} mb={5}>
      <Loader loading={loading} />
      <Grid container spacing={4} id="calculator" justifyContent="end">
        <Grid
          item
          xs={12}
          sm={7}
          md={8}
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingLeft: matches ? "auto !important" : "130px !important",
          }}
        >
          <Box width={{ xs: "95%", sm: "84%" }}>
            <Heading text="Staking Calculator" />
            <Pool1 init={init} apr={apr} setloading={setloading} />
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={5}
          md={4}
          sx={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Box component="img" src={donuts} alt="" />
        </Grid>
        <Grid item xs={12}>
          <Record data={stakeDetails} setloading={setloading} init={init} />
        </Grid>
      </Grid>
    </Box>
  );
}

export default Calculator;
